module.exports = __webpack_public_path__ + "img/other5.613732a3.png";